import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";

import { ApplicationState } from "../../../redux/ApplicationState";
import {
  getTrainingVideo,
  postTrainingVideo,
  putTrainingVideo,
} from "../../../actions/Training";
import AddEditTraining from "../components/AddEditTraining";

const mapStateToProps = ({
  addTrainingVideoState,
  editTrainingVideoState,
}: ApplicationState) => ({
  addTrainingVideoState: addTrainingVideoState,
  editTrainingVideoState: editTrainingVideoState.response,
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<ApplicationState, Record<string, never>, any>
) => {
  return {
    postTrainingVideo: (payload: FormData) => {
      dispatch(postTrainingVideo(payload));
    },
    putTrainingVideo: (payload: FormData) => {
      dispatch(putTrainingVideo(payload));
    },
    getTrainingVideo: () => {
      dispatch(getTrainingVideo());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddEditTraining);
